import React from 'react';

import { Box } from '@mui/material';
import { DataItem } from '../../atoms';

export type DataItemsProps = {
    items: Array<{
        title: string;
        content: string | number;
        contentType?: 'currency';
    }>;
};

export const DataItems: React.FunctionComponent<DataItemsProps> = function ({
    items,
}: DataItemsProps) {
    return (
        <Box>
            {items.map((item) => (
                <DataItem {...item} />
            ))}
        </Box>
    );
};
